import { NavLink } from '../interfaces/nav-links.interface';

export const NAV_LINKS: NavLink[] = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  {
    label: 'Booking',
    path: '/booking',
    children: [
      { label: 'Book Now', path: '/booking' },
      { label: 'Lax Booking', path: '/lax-booking' },
        { label: 'Book A Fleet', path: '/fleets' },
    ],
  },
  { label: 'Our Category', path: '/category' },
  { label: 'Our Fleets', path: '/fleets' },
  // { label: 'My Account', path: '/admin-dashboard' },
  { label: 'Contact Us', path: '/contact' },
];
